var PRIMEDefaultCohort1 = {
  "name": "DCCT conventional",
  "note": "",
  "version": 1,
  "project": null,
  "references": "Nathan et al. Diabetes control and complications trial/epidemiology of diabetes interventions and complications study at 30 years: advances and contributions. Diabetes. 2013;62(12):3976-86.",
  "male": {
  "proportion": 54.1
},
  "smokers": {
  "proportion": 18.4
},
  "takingAntiHypertensiveMedication": {
  "proportion": 2.1
},
  "takingAntiThromboticMedication": {
  "proportion": 0
},
  "takingPrimaryLipidModifyingMedication": {
  "proportion": 0
},
  "takingSecondaryLipidModifyingMedication": {
  "proportion": 0
},
  "age": {
  "mean": 26.7,
    "sd": 7.1
},
  "durationOfDiabetesAtBaseline": {
  "mean": 5.5,
    "sd": 4.1
},
  "hbA1c": {
  "mean": 9.1,
    "sd": 1.6
},
  "sbp": {
  "mean": 114.6,
    "sd": 11.4
},
  "totalCholesterolMmolL": {
  "mean": 4.55,
    "sd": 0.87
},
  "ldlmmolL": {
  "mean": 2.83,
    "sd": 0.76
},
  "hdlmmolL": {
  "mean": 1.3,
    "sd": 0.32
},
  "bmi": {
  "mean": 23.5,
    "sd": 2.9
},
  "neuropathyAtBaseline": {
  "proportion": 5.6
},
  "cardioVascularDiseaseAtBaseline": {
  "proportion": 0
},
  "macularEdemaAtBaseline": {
  "proportion": 0
},
  "cHFAtBaseline": {
  "proportion": 0
},
  "amputationAtBaseline": {
  "proportion": 0
},
  "retinopathyAtBaseline": {
  "stateProportionMap": {
    "NO": 79.6,
      "MILD_NPDR": 15.2,
      "MODERATE_NPDR": 5.1,
      "SEVERE_NPDR": 0.1,
      "PDR": 0,
      "SVL": 0
  }
},
  "renalStateDistributionAtBaseline": {
  "stateProportionMap": {
    "NORMAL": 90,
      "MICROALBUMINURIA": 10,
      "OVERT": 0,
      "ESRD": 0
  }
},
  "creationDate": 1528842435922,
  "creator": "pollock@ossianconsulting.com"
}
